import React from 'react';

const ArrowRight = ({ className }: { className?: string }) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 21.622 16"
			className={className}
		>
			<path
				fill="currentColor"
				d="M21.405 8.793a.132.132 0 0 0 .036-.108.273.273 0 0 0 .072-.144c0-.036.036-.072.036-.144 0-.036.036-.108.036-.144 0-.072.036-.144.036-.216v-.144a.457.457 0 0 0-.036-.216c0-.072-.036-.108-.036-.144s-.036-.072-.036-.108c-.036-.072-.072-.108-.108-.18 0-.036-.036-.036-.036-.072-.072-.072-.108-.144-.18-.216L14.667.435a1.45239733 1.45239733 0 1 0-2.054 2.054l4.072 4.072H1.441a1.4415 1.4415 0 0 0 0 2.883h15.243l-4.072 4.072a1.44 1.44 0 1 0 2.018 2.054l6.559-6.559z"
			/>
		</svg>
	);
};

export default ArrowRight;
